
import { useState } from 'react';
import { imageStorageService } from '../../services/imageStorageService';
import { enhancedTargetNotesService } from '../../services/enhancedTargetNotesService';
import { useToast } from '../../hooks/use-toast';
import { useChat } from '../../context/ChatContext';

export const useImageUploadForTarget = () => {
  const [isUploading, setIsUploading] = useState(false);
  const { toast } = useToast();
  const { currentTargetCode, currentSessionId } = useChat();

  const uploadImageForTarget = async (imageFile: File): Promise<boolean> => {
    if (!currentTargetCode || !currentSessionId) {
      toast({
        title: "Upload Error",
        description: "No active target found. Please generate a target first.",
        variant: "destructive"
      });
      return false;
    }

    try {
      setIsUploading(true);
      console.log('🖼️ useImageUploadForTarget: Starting image upload for target:', currentTargetCode);

      // Store the image note using the enhanced service
      const result = await enhancedTargetNotesService.storeImageNote(
        currentTargetCode,
        currentSessionId,
        imageFile,
        `Uploaded image: ${imageFile.name}`
      );

      if (result) {
        console.log('✅ useImageUploadForTarget: Image stored successfully:', result.id);
        toast({
          title: "Image Uploaded",
          description: `Successfully uploaded ${imageFile.name} for target analysis.`,
        });
        return true;
      } else {
        throw new Error('Failed to store image note');
      }
    } catch (error) {
      console.error('❌ useImageUploadForTarget: Upload failed:', error);
      toast({
        title: "Upload Failed",
        description: "Failed to upload image. Please try again.",
        variant: "destructive"
      });
      return false;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadImageForTarget,
    isUploading
  };
};
